import React, {useState} from 'react';
import {useDispatch} from "react-redux";
import MindsetsJsSDK, {
    ErrorMessageAction,
    LoadingAction
} from "mindsets-js-sdk";
import NumericValueField from "../../common/NumericValueField";

export default function () {
    const dispatch = useDispatch();

    const [model, setModel] = useState('amazon.titan-image-generator-v2:0');
    const [message, setMessage] = useState('Please create an image of an cartoon pony eating a bale of hay.');
    const [number, setNumber] = useState(null);
    const [ratio, setRatio] = useState("1:1");
    const [width, setWidth] = useState(null);
    const [scale, setScale] = useState(null);
    const [seed, setSeed] = useState(null);
    const [quality, setQuality] = useState(null);
    const [negative, setNegative] = useState(null);
    const [images, setImages] = useState([]);

    const [w, h] = ratio.split(':');
    const height = Math.round(width * parseInt(h) / parseInt(w));

    function submit() {
        dispatch(LoadingAction(true, 'Loading...'));
        const config = {
            taskType: "TEXT_IMAGE",
            textToImageParams: {
                text: message
            }
        };
        if (negative) {
            config.textToImageParams.negativeText = negative;
        }
        const imageGenerationConfig = {};
        if (quality) {
            imageGenerationConfig.quality = quality;
        }
        if (height) {
            imageGenerationConfig.height = height;
        }
        if (width) {
            imageGenerationConfig.width = width;
        }
        if (scale) {
            imageGenerationConfig.cfgScale = scale;
        }
        if (seed) {
            imageGenerationConfig.seed = seed;
        }
        if (Object.keys(imageGenerationConfig).length > 0) {
            config.imageGenerationConfig = imageGenerationConfig;
        }
        MindsetsJsSDK().API
            .post('ai/invoke', {model, config: JSON.stringify(config)})
            .then(response => {
                let images_new = JSON.parse(JSON.stringify(images));
                images_new = images_new.concat(response.reply.images);
                setImages(images_new);
            })
            .catch(error => {
                console.error(error);
                dispatch(ErrorMessageAction(error, true));
            })
            .finally(() => dispatch(LoadingAction(false)));
    }

    function detectFormat(string) {
        if (string.startsWith('iVBORw')) return 'png';
        if (string.startsWith('/9j/4A')) return 'jpg';
    }

    function renderModelSelector() {
        return (
            <div>
                <label>Model</label>
                <select
                    value={model}
                    onChange={event => {
                        setModel(event.target.value);
                    }}>
                    <option value='amazon.titan-image-generator-v2:0'
                            title='Text-to-image, Image-to-image, Background removal, Image conditioning'>Amazon
                        Titan Image Generator G1
                    </option>
                </select>
            </div>
        );
    }

    function renderNumber() {
        return (
            <div>
                <label>Number of images</label>
                <input
                    type="number"
                    value={number ? number.toString() : '1'}
                    min={1}
                    max={5}
                    onChange={event => {
                        setNumber(parseInt(event.target.value));
                    }}/>
            </div>
        );
    }

    function renderRatio() {
        return (
            <div>
                <label>Ratio</label>
                <select
                    value={ratio}
                    onChange={event => {
                        setRatio(event.target.value);
                    }}>
                    <option value='1:1'>1:1</option>
                    <option value='2:3'>2:3</option>
                    <option value='3:2'>3:2</option>
                    <option value='3:5'>3:5</option>
                    <option value='5:3'>5:3</option>
                    <option value='7:9'>7:9</option>
                    <option value='9:7'>9:7</option>
                    <option value='5:11'>5:11</option>
                    <option value='11:5'>11:5</option>
                    <option value='6:11'>6:11</option>
                    <option value='11:6'>11:6</option>
                    <option value='9:5'>9:5</option>
                    <option value='16:9'>16:9</option>
                </select>
            </div>
        );
    }

    function renderWidth() {
        return (
            <div>
                <label>Width(Optional. Default 1408)</label>
                <select
                    value={width ? width.toString() : ''}
                    onChange={event => {
                        setWidth(parseInt(event.target.value));
                    }}>
                    <option value=''></option>
                    <option value='320'>320</option>
                    <option value='384'>384</option>
                    <option value='448'>448</option>
                    <option value='512'>512</option>
                    <option value='576'>576</option>
                    <option value='640'>640</option>
                    <option value='704'>704</option>
                    <option value='768'>768</option>
                    <option value='896'>896</option>
                    <option value='1024'>1024</option>
                    <option value='1152'>1152</option>
                    <option value='1173'>1173</option>
                    <option value='1280'>1280</option>
                    <option value='1408'>1408</option>
                </select>
            </div>
        );
    }

    function renderHeight() {
        return (
            <div>
                <label>Height(Default 1408)</label>
                <div className='like-selector'>{height}</div>
            </div>
        );
    }

    function renderQuality() {
        return (
            <div>
                <label>Quality(Optional. Default Standard)</label>
                <select
                    value={quality ? quality : 'standard'}
                    onChange={event => {
                        setQuality(event.target.value);
                    }}>
                    <option value=''>-</option>
                    <option value='standard'>Standard</option>
                    <option value='premium'>Premium</option>
                </select>
            </div>
        );
    }

    function renderScale() {
        return (
            <div>
                <label>Scale(Optional. Default 8.0)</label>
                <NumericValueField
                    callback={setScale}
                    initial={scale}
                    min={1.1}
                    max={10.0}
                    precision={1}
                />
            </div>
        );
    }

    function renderSeed() {
        return (
            <div>
                <label>Seed(Optional. 0 - 2,147,483,646. Default 42.)</label>
                <NumericValueField
                    callback={setSeed}
                    initial={seed}
                    min={0}
                    max={2147483646}
                />
            </div>
        );
    }

    function renderNegative() {
        return (
            <div>
                <label>Negative Text(Optional)</label>
                <textarea
                    value={negative ? negative : ''}
                    onChange={event => {
                        if (event.target.value === '') {
                            setNegative(null);
                        } else {
                            setNegative(event.target.value);
                        }
                    }}
                    style={{width: '100%'}}
                    rows={4}
                />
                <div className='note'>Don't use negative words in the Negative Text prompt. For example, if you don't
                    want to include <strong className='text-success'>mirrors</strong> in an image, enter <strong
                        className='text-success'>mirrors</strong> in the Negative Text prompt. Don't enter <strong
                        className='text-success'>no mirrors</strong>.
                </div>
            </div>
        )
    }

    function renderPrompt() {
        return (
            <div>
                <label>Prompt</label>
                <textarea
                    value={message}
                    onChange={event => {
                        setMessage(event.target.value);
                    }}
                    style={{width: '100%'}}
                    rows={4}
                    onKeyDown={event => {
                        if (event.key === 'Enter') {
                            if (!event.shiftKey) {
                                event.preventDefault();
                                submit();
                            }
                        }
                    }}
                />
            </div>
        )
    }

    function renderImages() {
        return images.map((image, index) => {
            return (
                <div key={index} className='d-flex flex-column align-items-center'>
                    <img src={'data:image/jpeg;base64,' + image} alt='' style={{maxWidth: '100%'}}/>
                    <div className='d-flex flex-gap-10 align-items-center'>
                        <button
                            className='small'
                            onClick={() => {
                                const link = document.createElement('a');
                                link.href = 'data:image/jpeg;base64,' + image;
                                link.download = 'image_' + index + '.' + detectFormat(image);
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                            }}>Download
                        </button>
                    </div>
                </div>
            );
        });
    }

    return (
        <div className='container'>
            <title>Image Generator</title>
            <h1>Image Generator</h1>

            <div className='section'>
                {renderImages()}
            </div>
            <div className='section'>
                <form onSubmit={event => {
                    event.preventDefault();
                    submit();
                }}>
                    <div className='d-flex flex-gap-10 align-items-end flex-wrap'>
                        {renderModelSelector()}
                        {renderNumber()}
                        {renderRatio()}
                        {renderWidth()}
                        {renderHeight()}
                        {renderQuality()}
                        {renderScale()}
                        {renderSeed()}
                    </div>
                    <div>
                        <label>Scale - Specifies how strongly the generated image should adhere to the prompt. Use a
                            lower value to introduce more randomness in the generation.</label>
                        <label>Seed - Use to control and reproduce results. Determines the initial noise setting. Use
                            the same seed and the same settings as a previous run to allow inference to create a similar
                            image.</label>
                    </div>
                    <div className='section'>
                        <div className='row'>
                            <div className='col-9'>
                                {renderPrompt()}
                            </div>
                            <div className='col-3'>
                                {renderNegative()}
                            </div>
                        </div>
                    </div>
                    <button type='submit' disabled={!message}>Submit</button>
                </form>
            </div>
        </div>
    );
}